import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const WaveLayerSpinAccelerationListItem = ({ acceleration, index, updateWaveLayerSpinSettings }) => {
    const onAccelerationChange = (value) => {
        previewHistoryBatch.start();
        updateWaveLayerSpinSettings(index, "acceleration", value);
    };

    return (
        <SliderListItem
            title='Acceleration'
            toolTip={`Control how spin reacts to loud bass. At 0 acceleration there is no reactivity. Positive acceleration increases clockwise spin speed during loud bass. Negative acceleration increases count-clockwise spin speed during loud bass.`}
            value={acceleration}
            displayMultiplier={1}
            min={-100}
            max={100}
            step={1}
            onValueChange={onAccelerationChange}
        />
    );
};

const mapStateToProps = (state, { index }) => {
    const spinSettings = state.createPreview.present.videoSettings.visualizer.waveCircles[index]?.customOptions?.spinSettings;
    return { acceleration: spinSettings?.acceleration ?? 0 };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerSpinSettings: (index, key, value) => dispatch(createActions.updateWaveLayerSpinSettings(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerSpinAccelerationListItem);